<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Intermediary Comm/Disc Factor Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 v-if="newInterCommDiscFact">
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :label="labels.productType" v-model="appID" :items="appIDList" item-text="label" item-value="value" :error-messages="errors.collect('productType')" data-vv-name="productType" :data-vv-as="labels.productType" v-validate="'required'" @input="doProductType"></v-autocomplete>
                </v-flex>
                <v-flex xs8>
                  <v-autocomplete :label="labels.product" v-model="interCommDiscFactForm.product" :items="productList" item-text="label" item-value="value" :error-messages="errors.collect('product')" data-vv-name="product" :data-vv-as="labels.product" v-validate="'required'" :loading="productLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
              <div class="title">{{interCommDiscFactForm.product}}</div>
            </v-flex>
            <v-flex xs6 v-if="newInterCommDiscFact">
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="effDate" :label="labels.effDate" v-validate="'required'" :data-vv-as="labels.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')" @input="doEffDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="effTime" :label="labels.effTime" v-validate="'required'" :data-vv-as="labels.effTime" data-vv-name="effTime" :error-messages="errors.collect('effTime')" @input="doEffDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.effDateQuery}}</v-subheader>
              <div class="title">{{formatDateTime2(interCommDiscFactForm.effDate)}}</div>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="endDate" :label="labels.endDate" v-validate="endDateValidation" :min="this.effDate" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" @input="doEndDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="endTime" :label="labels.endTime" :data-vv-as="labels.endTime" data-vv-name="endTime" :error-messages="errors.collect('endTime')" @input="doEndDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="interCommDiscFactForm.fact1" :label="labels.fact1" item-text="label" item-value="value" :error-messages="errors.collect('fact1')" data-vv-name="fact1" :data-vv-as="labels.fact1" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="interCommDiscFactForm.fact2" :label="labels.fact2" item-text="label" item-value="value" :error-messages="errors.collect('fact2')" data-vv-name="fact2" :data-vv-as="labels.fact2" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="interCommDiscFactForm.fact3" :label="labels.fact3" item-text="label" item-value="value" :error-messages="errors.collect('fact3')" data-vv-name="fact3" :data-vv-as="labels.fact3" clearable></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="interCommDiscFactForm.fact4" :label="labels.fact4" item-text="label" item-value="value" :error-messages="errors.collect('fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="interCommDiscFactForm.fact5" :label="labels.fact5" item-text="label" item-value="value" :error-messages="errors.collect('fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="interCommDiscFactForm.fact6" :label="labels.fact6" item-text="label" item-value="value" :error-messages="errors.collect('fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" clearable></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newInterCommDiscFact? 'Add Inter Comm/Disc Factor' : 'Update Inter Comm/Disc Factor'}}
                <v-icon right>{{newInterCommDiscFact? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <inter-comm-disc-rates v-if="!newInterCommDiscFact" :interCommDiscRates="interCommDiscRates" :interCommDiscFacts="factorForm" @doRemove="doRemove"></inter-comm-disc-rates>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import InterCommDiscRates from './InterCommDiscRates'
import { ADMININTERMEDIARY_INTERCOMMDISCFACT, ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST } from '@/store/types'
import { formatDisplayNumber } from '@/utils/number'
import toDate from 'date-fns/toDate'
import { formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        productType: 'Product Type*',
        product: 'Product*',
        productQuery: 'Product',
        effDate: 'Effective Date*',
        effTime: 'Time*',
        effDateQuery: 'Effective Date',
        endDate: 'End Date',
        endTime: 'Time',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      interCommDiscFactForm: {
        inter: undefined,
        product: undefined,
        effDate: undefined,
        endDate: undefined,
        fact1: undefined,
        fact2: undefined,
        fact3: undefined,
        fact4: undefined,
        fact5: undefined,
        fact6: undefined,
        revision: undefined
      },
      appID: undefined,
      productLoading: false,
      productList: [],
      menu: [],
      newInterCommDiscFact: false,
      submitting: false,
      interCommDiscRates: [],
      effDate: undefined,
      effTime: undefined,
      endDate: undefined,
      endTime: undefined,
      factor1to3Loading: false,
      factor1to3List: [],
      factor4to6Loading: false,
      factor4to6List: []
    }
  },
  computed: {
    appIDList() {
      return this.$store.state.adminInter.intermediary.appIDList
    },
    factorForm() {
      const result = {
        fact1: this.interCommDiscFactForm.fact1,
        fact2: this.interCommDiscFactForm.fact2,
        fact3: this.interCommDiscFactForm.fact3,
        fact4: this.interCommDiscFactForm.fact4,
        fact5: this.interCommDiscFactForm.fact5,
        fact6: this.interCommDiscFactForm.fact6
      }
      return result
    },
    endDateValidation() {
      return 'start_enddate:' + this.interCommDiscFactForm.effDate
    }
  },
  methods: {
    async doInit() {
      if (!this.newInterCommDiscFact) {
        this.interCommDiscFactForm.product = this.product
        this.interCommDiscFactForm.effDate = this.effectiveDate
        // Review
        await this.reviewInterCommDiscFact()
        await Promise.all([this.getFactor1to3List(), this.getFactor4to6List()])
        this.queryInterCommDiscRate()
      }
    },
    doEffDate() {
      // Format Effective Date
      if (this.effDate && this.effTime && this.effTime.length === 5) {
        const hr = this.effTime.substring(0, 2)
        const min = this.effTime.substring(3, 5)
        this.effDate = toDate(this.effDate)
        this.effDate.setHours(hr)
        this.effDate.setMinutes(min)
        this.interCommDiscFactForm.effDate = this.effDate
      }
    },
    doEndDate() {
      // Format Expiry Date
      if (this.endDate && this.endTime && this.endTime.length === 5) {
        const hr = this.endTime.substring(0, 2)
        const min = this.endTime.substring(3, 5)
        this.endDate = toDate(this.endDate)
        this.endDate.setHours(hr)
        this.endDate.setMinutes(min)
        this.interCommDiscFactForm.endDate = this.endDate
      } else {
        this.interCommDiscFactForm.endDate = undefined
      }
    },
    async reviewInterCommDiscFact() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscFactorGet
      if (apiURI) {
        try {
          const expand = {
            inter: this.inter,
            product: this.interCommDiscFactForm.product,
            effDate: formatDisplayDateTime2(this.interCommDiscFactForm.effDate)
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Inter Comm/Disc Factor init
            this.interCommDiscFactForm.inter = data.interCommDiscFact.inter
            this.interCommDiscFactForm.product = data.interCommDiscFact.product
            this.appID = data.interCommDiscFact.productAppId
            this.interCommDiscFactForm.fact1 = data.interCommDiscFact.fact1
            this.interCommDiscFactForm.fact2 = data.interCommDiscFact.fact2
            this.interCommDiscFactForm.fact3 = data.interCommDiscFact.fact3
            this.interCommDiscFactForm.fact4 = data.interCommDiscFact.fact4
            this.interCommDiscFactForm.fact5 = data.interCommDiscFact.fact5
            this.interCommDiscFactForm.fact6 = data.interCommDiscFact.fact6
            this.interCommDiscFactForm.revision = data.interCommDiscFact.revision
            this.interCommDiscFactForm.effDate = data.interCommDiscFact.effDate
            this.interCommDiscFactForm.endDate = data.interCommDiscFact.endDate
            if (this.interCommDiscFactForm.effDate) {
              this.effDate = this.interCommDiscFactForm.effDate
              this.effTime = formatDisplayTime(this.interCommDiscFactForm.effDate)
            }
            if (this.interCommDiscFactForm.endDate) {
              this.endDate = this.interCommDiscFactForm.endDate
              this.endTime = formatDisplayTime(this.interCommDiscFactForm.endDate)
            } else {
              this.endTime = '00:00'
            }

            const interCommDiscFactors = {
              fact1: this.interCommDiscFactForm.fact1,
              fact2: this.interCommDiscFactForm.fact2,
              fact3: this.interCommDiscFactForm.fact3,
              fact4: this.interCommDiscFactForm.fact4,
              fact5: this.interCommDiscFactForm.fact5,
              fact6: this.interCommDiscFactForm.fact6
            }
            this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT, interCommDiscFactors)
            const commitData = {
              interCommDiscFactTab: 1,
              displayFactReviewTab: true,
              product: this.interCommDiscFactForm.product,
              effDate: this.interCommDiscFactForm.effDate
            }
            this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doProductType() {
      this.getProducts()
      this.factor1to3List = undefined
      this.factor4to6List = undefined
      this.getFactor1to3List()
      this.getFactor4to6List()
      const commitData = {
        factor1to3List: this.factor1to3List,
        factor4to6List: this.factor4to6List,
        appId: this.appID
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST, commitData)
    },
    async getProducts() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.productList
      if (apiURI) {
        try {
          this.productLoading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.productList = data
          }
          this.productLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newInterCommDiscFact) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interCommDiscFactForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewInterCommDiscFact()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscFactorCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interCommDiscFactForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newInterCommDiscFact = false
            await this.reviewInterCommDiscFact()
            this.queryInterCommDiscRate()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async queryInterCommDiscRate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscRates
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            inter: this.inter,
            product: this.interCommDiscFactForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.interCommDiscRates = []
              data.map((interCommDiscRate) => {
                const convertInterCommDiscRate = {
                  inter: interCommDiscRate.inter,
                  product: interCommDiscRate.product,
                  displayEffDate: this.formatDateTime2(interCommDiscRate.effDate),
                  effDate: interCommDiscRate.effDate,
                  endDate: this.formatDateTime2(interCommDiscRate.endDate),
                  commGN: interCommDiscRate.commGN,
                  commPct: interCommDiscRate.commPct,
                  discPct: interCommDiscRate.discPct,
                  fact1: interCommDiscRate.fact1,
                  fact2: interCommDiscRate.fact2,
                  fact3: interCommDiscRate.fact3,
                  fact4: this.formatDisplayNumber(interCommDiscRate.fact4),
                  fact5: this.formatDisplayNumber(interCommDiscRate.fact5),
                  fact6: this.formatDisplayNumber(interCommDiscRate.fact6),
                  protComm: this.formatBoolean(interCommDiscRate.protComm),
                  protDisc: this.formatBoolean(interCommDiscRate.protDisc),
                  revision: interCommDiscRate.revision
                }
                this.interCommDiscRates.push(convertInterCommDiscRate)
              })
            } else {
              this.interCommDiscRates = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doRemove(selectedInterCommDiscRate) {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscRateDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          inter: selectedInterCommDiscRate.inter,
          product: selectedInterCommDiscRate.product,
          effDate: selectedInterCommDiscRate.effDate,
          fact1: selectedInterCommDiscRate.fact1,
          fact2: selectedInterCommDiscRate.fact2,
          fact3: selectedInterCommDiscRate.fact3,
          fact4: selectedInterCommDiscRate.fact4,
          fact5: selectedInterCommDiscRate.fact5,
          fact6: selectedInterCommDiscRate.fact6
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryInterCommDiscRate()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    },
    async getFactor1to3List() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.factor1to3ListGet
      if (apiURI) {
        try {
          this.factor1to3Loading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.factor1to3List = data
          }
          const commitData = {
            factor1to3List: this.factor1to3List,
            factor4to6List: this.factor4to6List,
            appId: this.appID
          }
          this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST, commitData)
          this.factor1to3Loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async getFactor4to6List() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.factor4to6ListGet
      if (apiURI) {
        try {
          this.factor4to6Loading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.factor4to6List = data
          }
          const commitData = {
            factor1to3List: this.factor1to3List,
            factor4to6List: this.factor4to6List,
            appId: this.appID
          }
          this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST, commitData)
          this.factor4to6Loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    if (this.product === 'New') {
      this.newInterCommDiscFact = true
      this.interCommDiscFactForm.inter = this.inter
      this.effTime = '00:00'
      this.endTime = '00:00'
    } else {
      this.doInit()
    }
  },
  props: {
    inter: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    effectiveDate: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    InterCommDiscRates
  }
}
</script>

<style lang="scss">

</style>
